import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Alert, Spin } from "antd";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const CustomSpin = ({ alertProps }) => (
  <Spin indicator={antIcon} className="text-custom_primary">
    {alertProps && <Alert {...alertProps} />}
  </Spin>
);

export default CustomSpin;
